













import Vue from 'vue'
import { GifBannerElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'GifBanner',

  data: () => ({
    imgError: false
  }),

  props: {
    templateItemData: {
      type: Object as () => GifBannerElInterface,
      required: true
    }
  }
})
